import { PropertyValueMap, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";
import { resolveMarkdown } from "./Directives/Markdown";
import { litIf } from "./LitUtils";

export type CacheTypeT = "default" | "no-store" | "reload" | "no-cache";

export const MarkdownLightStyle = css`
    ds-markdown::part(body) {
        color: black;
    }
`;

@customElement("ds-markdown")
export class Markdown extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }
        `,
    ];

    @property({ type: String }) cache: CacheTypeT | undefined;
    @property({ type: String }) url: string | undefined;
    @property({ type: String }) markdown: string | undefined;

    protected override async firstUpdated(
        _changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>
    ): Promise<void> {
        if (this.url) {
            const response = await window.fetch(
                this.url,
                this.cache ? { cache: `${this.cache}` } : undefined
            );
            if (response.status === 200) {
                this.markdown = await response.text();
            }
        }
    }

    override render() {
        return html`<article part="body">
            ${litIf(!!this.markdown, () => html`${resolveMarkdown(this.markdown as string)}`)}
        </article>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-markdown": Markdown;
    }
}
